import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { DELETE_ANNOUNCEMENT_URL } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useDeleteAnnouncement = ({ onSuccess, onError, uuid }: Input) => {
  const deleteAnnouncement = async (announcementType: string) => {
    await axiosClient.delete<void>(DELETE_ANNOUNCEMENT_URL(uuid), {
      data: {
        announcementType,
      },
    });
  };

  return useCustomMutation(deleteAnnouncement, {
    onSuccess,
    onError,
  });
};
